import React from "react";

import { sidebarOnClicks, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Glyphicon } from "react-bootstrap";
import { Navigation, Link, History } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar";

import ZOOM_CUSTOMIZATION_EXAMPLES from "resources/img/zoom-ui-examples.jpg";
import facetecFrame from "resources/img/facetec-ui-frame.png";
import facetecOverlay from "resources/img/facetec-ui-overlay.png";
import zoomGetReadyScreen from "resources/img/zoom-ui-get-ready-screen.jpg";
import THEME_WELL_ROUNDED from "resources/img/theme_well_rounded.gif";
import THEME_PSEUDO_FULLSCREEN from "resources/img/theme_pseudo_fullscreen.gif";
import THEME_FACETEC from "resources/img/theme_facetec.gif";
import THEME_EKYC from "resources/img/theme_ekyc.gif";
import zoomYourAppLogo from "resources/img/zoom-ui-your-app-logo.png";
import ZOOM_LOW_LIGHT_MODE from "resources/img/zoom_lowlight_mode.png";
import ZOOM_PSEUDO_FULLSCREEN from "resources/img/zoom_pseudo_fullscreen.png";
import RETRY_CUSTOMIZATIONS from "resources/img/retry_screen_customizations.jpg";

import facetecCustomizations1 from "resources/img/facetec-ui-customizations-01.png";
import facetecCustomizations2 from "resources/img/facetec-ui-customizations-02.png";
import facetecCustomizations3 from "resources/img/facetec-ui-customizations-03.png";
import facetecCustomizations4 from "resources/img/facetec-ui-customizations-04.png";
import facetecCustomizations5 from "resources/img/facetec-ui-customizations-05.png";
import facetecCustomizations6 from "resources/img/facetec-ui-customizations-06.png";
import facetecCustomizations7 from "resources/img/facetec-ui-customizations-07.png";
import facetecCustomizations8 from "resources/img/facetec-ui-customizations-08.png";
import facetecCustomizations9 from "resources/img/facetec-ui-customizations-09.png";
import facetecCustomizations10 from "resources/img/facetec-ui-customizations-10.png";
import facetecCustomizations11 from "resources/img/facetec-ui-customizations-11.png";
import facetecCustomizations12 from "resources/img/facetec-ui-customizations-12.png";
import facetecCustomizations13 from "resources/img/facetec-ui-customizations-13.png";
import facetecCustomizations14 from "resources/img/facetec-ui-customizations-14.png";

export default React.createClass({

  mixins: [Navigation],

  displayName: "Advanced Developer Guide",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  getInitialState() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      error: "",
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
    sidebarOnClicks()
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },


  render: function() {
      return (
        <div className="dash support">
          <div className="workspace">
            <div className="workspace__container">
              <section>
                <div className="title">
                  <Glyphicon glyph="user" />
                  <h2 id="zoom-ui-customization-reference">FaceTec UI Customization Reference</h2>
                </div>
                <p>Learn how to customize each UI component in the FaceTec SDK UX.</p>
                <hr/>
              </section>
              <section>

              <h3 id="facetec-ui-examples">FaceTec UI Examples</h3>
                <p>The FaceTec Interface is highly customizable and allows you to change all colors, fonts, borders, icons, text/strings, backgrounds, and buttons.  Please see the designs below for examples of UI that is 100% achievable using the out-of-box customizations provided by FaceTec.  Check out the Design Showcase button in the Sample Apps to see some of these designs in action, and the code needed to implement them in your App.</p>
                  <p style={{textAlign: "center"}}><img style={{marginTop: "1px", maxHeight: "250px", maxWidth: "100%"}} src={ZOOM_CUSTOMIZATION_EXAMPLES} /></p>

                  <hr />

                <h4 id="the-facetec-frame">The FaceTec Frame</h4>
                <p>The FaceTec Frame is the rectangular container that pops up over your App's interface when you start a 3D Liveness Check.  The reference diagrams at the bottom of this page for more details about the various ways that you can customize the FaceTec Frame.</p>
                <p style={{textAlign: "center"}}><img style={{marginTop: "1px"}} src={facetecFrame}  width="40%" /></p>

                <hr />

                <h4 id="the-facetec-overlay">The FaceTec Outer Overlay</h4>
                <p>The FaceTec Outer Overlay is the area <strong>outside</strong> of the FaceTec Frame.  The default color for this area is white, but can be changed to any color, including full or semi-transparency to expose your Application UI.  This  allows for a high degree of flexibility in customizing and branding the experience in your App.  For instance, you can create a custom blur effect on your own interface and add custom branding logos in a custom location that show concurrently to the User performing a 3D Liveness Session.</p>
                <p style={{textAlign: "center"}}><img style={{marginTop: "1px"}} src={facetecOverlay}  width="40%" /></p>

                <hr />

                <h4 id="low-light-mode">Low Light Mode</h4>
                <p>FaceTec SDKs detects when the User is in a low-light situation, and uses the Device APIs to brighten the screen and transitions the FaceTec Frame and Outer Overlay colors to white. This will properly illuminate the User's face and improve accuracy and success rates.</p>
                <p>The UI look and feel of Low Light mode can be individually customized by calling <code>ZoomSDK.setLowLightModeCustomization</code>, which takes a standard <code>ZoomCustomization</code> object.  All customizations on this object will be respected and transitioned to in Low Light mode <strong>except</strong> the Overlay and Frame background colors, as these must be changed to white to provide better performance.</p>
                <p style={{textAlign: "center"}}><img style={{marginTop: "1px"}} src={ZOOM_LOW_LIGHT_MODE}  width="40%" /></p>

                <hr />

                <h4 id="the-get-ready-screen">The Get Ready Screen</h4>
                <p>The Get Ready Screen dramatically increases first time User success rates, allowing Users to quickly familiarize themselves with the FaceTec SDK interface, align their face, and (in some cases) adjust their environment before starting the session.  The result is a consistent and expected experiences.</p>
                <p style={{textAlign: "center"}}><img style={{marginTop: "1px"}} src={zoomGetReadyScreen}  width="60%" /></p>

                <blockquote><p><strong>The Get Ready Screen dramatically improves User Success Rates and cannot be disabled.</strong></p></blockquote>

                <hr />

                <h4 id="the-retry-screen">The Retry Screen</h4>
                <p>FaceTec SDKs <Link to="/usability-and-success">succeeds on the first attempt for most Users</Link>. In the event that a retry is needed, the FaceTec SDK Retry Screen will display.  The guidance presented on this screen allows Users to quickly and intuitively understand how to improve their next capture  The Retry Screen has the following components:</p>
                <ul>
                  <li><p>An image of the User from the Session (on the left).  This provides the User with a quick and intuitive idea of the environmental conditions that caused their session to reject.</p></li>
                  <li><p>An example of an image with good pose and lighting.  This image can be fully customized to any image you want, can be randomized or ordered in custom fashion,  and can also be configured to rotating slideshow of images.</p></li>
                  <li><p>Text guidance to the User.  This text is also fully customizable.</p></li>
                </ul>

                <p style={{textAlign: "center"}}><img style={{marginTop: "1px", maxHeight: "250px", maxWidth: "100%"}} src={RETRY_CUSTOMIZATIONS} /></p>

                <blockquote><p><strong>The Retry Screen dramatically improves User Success Rates and cannot be disabled.</strong></p></blockquote>

                <hr />

                <h4 id="progress-success-screen">Progress/Success Screen</h4>
                <p>A required part of Device SDK integration includes implementing the <code>processZoomSessionResultWhileZoomWaits</code> function.  This function is responsible for sending the FaceTec 3D FaceMap and other data to your own web servoice. then to your instance(s) of FaceTec Server.  During the network request, a simple and customizable progress interface is displayed to the User.</p>
                <p>FaceTec Server will sometimes signal that the User needs to try perfoming a Liveness Check again — in these cases it is imperative for best User experience that FaceTec SDK is already loaded, resources are initialized, the camera is opened, and the FaceTec SDK interface is already built.  This allows for a very smooth and controlled transition between all screens in the FaceTec SDK experience, accounting for performance differences across devices, platform versions differences, camera differences, and form factor differences across a landscape of thousands of devices. </p>
                <div className="row" style={{textAlign: "center"}}>
                  <div className="col-xs-3">
                    <img style={{marginTop: "1px", maxHeight: "250px", maxWidth: "100%"}} src={THEME_FACETEC} />
                  </div>
                  <div className="col-xs-3">
                    <img style={{marginTop: "1px", maxHeight: "250px", maxWidth: "100%"}} src={THEME_PSEUDO_FULLSCREEN} />
                  </div>
                  <div className="col-xs-3">
                    <img style={{marginTop: "1px", maxHeight: "250px", maxWidth: "100%"}} src={THEME_WELL_ROUNDED} />
                  </div>
                  <div className="col-xs-3">
                    <img style={{marginTop: "1px", maxHeight: "250px", maxWidth: "100%"}} src={THEME_EKYC} />
                  </div>
                </div>
                <blockquote><p><strong>Due to its importance to the overall User experience, the Progress/Success Screen cannot be disabled.</strong></p></blockquote>

                <hr />
                <h4 id="disabling-screens">Disabling Screens</h4>
                <p><strong>Screen disablement is not allowed in the FaceTec SDK, no exceptions.</strong></p>
                <p>Due to their importance to the overall User experience and success rates, the Get Ready, Retry, and Progress/Result Screens cannot be disabled.</p>

                <hr />

                <h4 id="your-app-logo">The "Your App Logo"</h4>
                <p>The FaceTec SDK provides a quick and easy way to insert your own logo to be displayed during the entire session. This can be completely removed via the <code>ZoomCustomization</code> class and 100% of the area outside of the FaceTec Frame is under your control.</p>
                  <p style={{textAlign: "center"}}><img style={{marginTop: "1px"}} src={zoomYourAppLogo}  width="40%" /></p>

                <hr />

                <h4 id="facetec-as-a-full-screen-takeover">Can I use FaceTec SDKs as a full screen takeover?</h4>
                <p>Yes. Check out the "Pseudo-Fullscreen" theme in the Design Showcase in the Sample App.  By making the FaceTec Frame and the FaceTec Outer Overlay the same color, and turning the borders off, you effectively get a full-screen experience.  You can also customize the cancel button to be located outside of the FaceTec Frame to get the desired full-screen effect.</p>

                <p style={{textAlign: "center"}}><img style={{marginTop: "1px"}} src={ZOOM_PSEUDO_FULLSCREEN}  height="300px" /></p>

                <blockquote><p>Note: this is called "Pseudo-Fullscreen" because UI merely "looks fullscreen" because there are no visible frames.</p></blockquote>

                <hr />

                <h4 id="move-facetec-frame-down">Can I move the FaceTec Frame down?  Can I shrink or expand the FaceTec Frame?</h4>
                <p><strong>No (for very good, well-tested reasons)</strong>.</p>
                <p>FaceTec SDKs are rendered at a specific size and with a very small margin from the top of the screen.  There are several important reasons for this:</p>
                <ol>
                  <li>Maintaining Your App's UX/Branding: As a pop-over, you have 100% control over everything seen outside of the FaceTec Frame.  This gives you full control to design an experience where the FaceTec SDKs can feel to the User like they never left your App.  Please see the FaceTec Outer Overlay section above for more details.  You should also check the various themes in the Sample App Design Showcase (just click the "Design Showcase" button in the Sample Apps).  Many of these themes demonstrate showing Custom UI outside of the FaceTec Frame.</li>
                  <li>User Experience:  With a smaller-than-fullscreen popover, Users perceive a very simple alignment task.  A larger Frame creates a very  "in your face" experience that is much harder to align due to the physical surface area that needs to be covered by the User's eyes in order to determine proper alignment.  To understand this effect, try opening your tablet's built-in selfie camera and hold it a foot from your face.</li>
                  <li>Algorithmic Accuracy:  The FaceTec SDK algorithms are trained on real Users that are looking almost directly into the camera.  The algorithms require this for good accuracy.</li>
                  <li>Compatibility: FaceTec SDKs compensate for the <strong>extremely broad</strong> surface area of combinations of platforms, platform versions, screen sizes and densities, camera qualities and aspect differences.  Instead of us requiring each developer to figure all of this out themselves, FaceTec SDks do all of the work for you and renders at the right size and in the right location on every device/platform combination.</li>
                </ol>
                <p>For all of these reasons, customizing the SDKs to take over the entire screen and/or moving the FaceTec Frame is not allowed.</p>

                <hr />

                <h4 id="move-action-buttons">Can I Move the "I'm Ready" Button or other Action Buttons to the Bottom of the Screen?</h4>
                <p>No, this cannot be moved.  The "I'm Ready" Button vertical location cannot be moved lower as it would cause the User to be looking at the very bottom of their screen when they start the session, which would cause your application to have sub-optimal accuracy.  This is also not desired in order to maintain compatibility with tens of thousands of device/platform/version combinations.</p>

                <hr />

                <h4>Can I Resize the "I'm Ready" Button or other Action Buttons?</h4>
                <p>You can specify the width of the FaceTec SDK Action Buttons, but you may not change the height.  The height cannot be specified because there has been considerable technology built into sizing the button correctly given the tens of thousands of device, screen, platform version, and camera resolution combinations that exist.  The button is rendered at the height it is to leave room for other required interface elements on the screen and ensure that all interface elements on the screen can render in a readable and intuitive manner.</p>

                <hr />

                <h4 id="resize-move-or-disable-the-your-app-logo">Can I resize, move, or disable the "Your App Logo"?</h4>
                <p>Yes, you have two choices on how to customize the Your App Logo and, in general, the area outside of the FaceTec Frame:</p>
                <ol>
                  <li>Customize the logo as is.  FaceTec SDKs chooses a size and location that is well-aligned and appropriately sized for the device.</li>
                  <li>Disable the logo, and perform any customization outside of the FaceTec Frame you would like.  The Sample App's non-default themes demonstrate disabling the app logo and showing custom UI outside of the FaceTec Frame.</li>
                </ol>

                <hr />
                <h4 id="facetec-customizations-reference">FaceTec Customizations - Developer Reference</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations1}  width="100%" /></p>

                <h4 id="facetec-customizations-elements">FaceTec Customizations - Customizable Elements</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations2}  width="100%" /></p>

                <h4 id="facetec-customizations-all-common-customizations">FaceTec Customizations - All Common Customizations</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations3}  width="100%" /></p>

                <h4 id="facetec-customizations-get-ready-screen">FaceTec Customizations - Get Ready Screen</h4>
                <p>Allows users to align their face in the FaceTec Oval prior to starting the FaceTec Session. Provides additional user experience and security checks.</p>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations4}  width="100%" /></p>

                <h4 id="facetec-customizations-get-ready-screen-2">FaceTec Customizations - Get Ready Screen - Additional Customizations</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations5}  width="100%" /></p>

                <h4 id="facetec-customizations-retry-screen">FaceTec Customizations - Retry Screen</h4>
                <p>Shown as the first screen after FaceTec determines that the user must provide another FaceTec Session -- Demonstrates good lighting and pose allowing users to quickly understand how to fix their environmental conditions.</p>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations6}  width="100%" /></p>

                <h4 id="facetec-customizations-retry-screen-2">FaceTec Customizations - Retry Screen - Additional Customizations</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations7}  width="100%" /></p>

                <h4 id="facetec-customizations-standard-initializing-progress-and-success-screen">FaceTec Customizations - Standard Initializing, progress and Success Screen</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations8}  width="100%" /></p>

                <h4 id="facetec-customizations-additional-initializing-progress-and-success-screen">FaceTec Customizations -Additional Animation Customizations</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations14}  width="100%" /></p>

                <h4 id="facetec-customizations-id-scan-common-customizations">FaceTec Customizations - ID Scan Common Customizations</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations9}  width="100%" /></p>

                <h4 id="facetec-customizations-id-scan-screens-1">FaceTec Customizations - ID Scan Screens</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations10}  width="100%" /></p>

                <h4 id="facetec-customizations-id-scan-screens-2">FaceTec Customizations - ID Scan Screens</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations11}  width="100%" /></p>

                <h4 id="facetec-customizations-camera-permissions-screen">FaceTec Customizations - Camera Permissions Screen</h4>
                <p>iOS/Android - Camera Permissions Screen can be disabled if developer previously acquires camera permissions</p>
                <p>Browser - Camera Help Screen can be customized or disabled.</p>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations12}  width="100%" /></p>

                <h4 id="facetec-customizations-iframe">FaceTec Customizations - iFrame</h4>
                <p style={{textAlign: "center"}}><img style={{marginTop: "15px"}} style={{marginBottom: "15px"}} src={facetecCustomizations13}  width="100%" /></p>

              </section>
              <br></br>
                <section>
                  <h4 id="strings-reference">Strings Reference</h4>

                  <p><strong>Get Ready Screen</strong></p>
                      <ol>
                         <li><code>zoom_instructions_header_ready</code></li>
                         <li><code>zoom_instructions_message_ready</code></li>
                         <li><code>zoom_action_im_ready</code></li>
                      </ol>

                  <p><strong>Main Interface</strong></p>
                      <ol>
                         <li><code>zoom_feedback_*</code> Depending on platform, ~10-14 strings to configure here for various feedback. </li>
                      </ol>

                  <p><strong>Retry Screen</strong></p>
                      <ol>
                         <li><code>zoom_retry_header</code></li>
                         <li><code>zoom_retry_subheader_message</code></li>
                         <li><code>zoom_retry_your_image_label</code></li>
                         <li><code>zoom_retry_ideal_image_label</code></li>
                         <li><code>zoom_retry_instruction_message_1</code></li>
                         <li><code>zoom_retry_instruction_message_2</code></li>
                         <li><code>zoom_retry_instruction_message_3</code></li>
                         <li><code>zoom_action_ok</code></li>
                      </ol>

                  <p><strong>Progress and Success Screen</strong></p>
                      <ol>
                         <li><code>zoom_result_facemap_upload_message</code></li>
                         <li><code>zoom_result_idscan_upload_message</code></li>
                         <li><code>zoom_result_facemap_success_message </code></li>
                      </ol>

                  <p><strong>ID Scan Selection Screen</strong></p>
                      <ol>
                         <li><code>zoom_idscan_type_selection_header</code></li>
                         <li><code>zoom_action_select_id_card</code></li>
                         <li><code>zoom_action_select_passport</code></li>
                      </ol>

                  <p><strong>ID Scan Capture & Review Screen</strong></p>
                      <ol>
                         <li><code>zoom_idscan_capture_id_card_front_instruction_message</code></li>
                         <li><code>zoom_idscan_capture_id_card_back_instruction_message</code></li>
                         <li><code>zoom_idscan_capture_passport_instruction_message</code></li>
                         <li><code>zoom_idscan_capture_tap_to_focus_message</code>*Android/iOS only.</li>
                         <li><code>zoom_idscan_review_id_card_front_instruction_message</code></li>
                         <li><code>zoom_idscan_review_id_card_back_instruction_message</code></li>
                         <li><code>zoom_idscan_review_passport_front_instruction_message</code></li>
                         <li><code>zoom_action_take_photo</code></li>
                         <li><code>zoom_action_accept_photo</code></li>
                         <li><code>zoom_action_retake_photo</code></li>
                      </ol>

                  <p><strong>ID Scan Result Screen</strong></p>
                      <ol>
                         <li><code>zoom_result_idscan_success_message</code></li>
                         <li><code>zoom_result_idscan_unsuccess_message</code></li>
                      </ol>

                  <p><strong>Camera Permission Screen</strong></p>
                      <ol>
                         <li><code>zoom_camera_permission_enable_camera</code>*Android/iOS only.</li>
                         <li><code>zoom_camera_permission_message_enroll</code>*Android/iOS only.</li>
                         <li><code>zoom_camera_permission_message_auth</code>*Android/iOS only.</li>
                         <li><code>zoom_camera_permission_launch_settings</code></li>
                         <li><code>zoom_initializing_camera</code>*Browser only.</li>
                         <li><code>zoom_camera_permission_message</code>*Browser only.</li>
                         <li><code>zoom_browser_camera_help_action_link</code> *Browser only.</li>
                      </ol>

                      <p><strong>iFrame</strong></p>
                      <ol>
                         <li><code>zoom_enter_fullscreen_header</code></li>
                         <li><code>zoom_enter_fullscreen_message</code></li>
                         <li><code>zoom_enter_fullscreen_action</code></li>
                      </ol>

                  </section>

              <SDKSidebar menuType="main" title="UI Customization"/>
            </div>
          </div>
        </div>
        );
      },
    });



// WEBPACK FOOTER //
// ./src/js/components/screens/ui-customization.jsx